import { v4 as uuid_v4 } from "uuid";

export const nameof = <T>(name: keyof T): string => name as string;

export const shortKey = (): string => {
    // crypto.randomUUID() requires a secure context. The browser won't allow you to use it outside HTTPS when not accessing via localhost.
    // return crypto.randomUUID().substring(0, 6);
    return String(uuid_v4()).substring(0, 6);
};
